import React from 'react';
import { Check, Dna, Lock, ShieldCheck } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { listPrice, todayPrice, totalValue } from '../data/valueStack';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/tkNTLZc3GVXwYzNyi9EpAt/peptides-mockup.png';
const motes = [{
  left: '44%',
  bottom: '60px',
  delay: '0s'
}, {
  left: '58%',
  bottom: '40px',
  delay: '1.6s'
}, {
  left: '38%',
  bottom: '90px',
  delay: '3.2s'
}, {
  left: '63%',
  bottom: '20px',
  delay: '4.4s'
}, {
  left: '50%',
  bottom: '110px',
  delay: '2.4s'
}];
const trustItems = [{
  icon: ShieldCheck,
  label: 'Garantía 30 días'
}, {
  icon: Lock,
  label: 'Pago seguro'
}, {
  icon: Check,
  label: '+15 bonos incluidos'
}];
export function Hero() {
  return <section className="relative flex min-h-[calc(100svh-2rem)] w-full flex-col items-center overflow-hidden bg-gradient-to-b from-ink-850 via-ink-900 to-ink-950" data-id="element-61" data-mp="nbydopvr4v83">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_720px_420px_at_50%_34%,rgba(201,162,74,0.16),transparent_62%)]" aria-hidden="true" data-id="element-62" data-mp="381e1dbzoc3ti" />
      {/* Capas decorativas costosas: sólo desde tablet hacia arriba */}
      <div className="stage-grid pointer-events-none absolute inset-0 hidden sm:block" aria-hidden="true" data-id="element-63" data-mp="39alaige2es47" />
      <div className="spot-beam pointer-events-none absolute -top-12 left-1/2 hidden h-[640px] w-[520px] -translate-x-1/2 animate-beam-flicker sm:block" aria-hidden="true" data-id="element-64" data-mp="3e8egb8bghk3y" />
      <div className="stage-vignette pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-65" data-mp="359t19n570n7x" />

      <div className="relative z-10 flex w-full flex-1 flex-col items-center px-4 pb-8 pt-5 sm:px-8 sm:pb-12 sm:pt-10" data-id="element-66" data-mp="2qkmv1f7xtwqj">
        <span className="inline-flex animate-fade-up items-center gap-2 rounded-full border border-gold-400/45 bg-gradient-to-b from-gold-400/[0.14] to-gold-400/[0.03] px-4 py-1.5 font-mono text-[9.5px] uppercase tracking-[0.18em] text-gold-300 sm:text-[10px]" data-id="element-67" data-mp="2vjg6z37ktfol">
          <Dna className="h-3 w-3 shrink-0" strokeWidth={1.8} aria-hidden="true" data-id="element-68" data-mp="s2joa067q6l3" />
          Protocolo Lujo de Farmacia
        </span>

        <h1 className="mt-3.5 max-w-4xl animate-fade-up text-balance text-center text-[25px] font-extrabold leading-[1.13] tracking-[-0.012em] text-[#f5f3ee] sm:mt-4 sm:text-4xl md:text-[42px]" style={{
        animationDelay: '80ms'
      }} data-id="element-69" data-mp="n9qhz7v3iq6w">
          ¿Es Usted un Biohacker Inteligente o Simplemente la{' '}
          <span className="gold-text" data-id="element-70" data-mp="1ayt68yk8jhad">"Caja Chica"</span> de una Clínica de Lujo?
        </h1>

        <p className="mt-3 max-w-xl animate-fade-up text-center text-[12.5px] leading-relaxed text-[#a7adb8] sm:mt-4 sm:text-sm" style={{
        animationDelay: '160ms'
      }} data-id="element-71" data-mp="15zq2dhfzrh3z">
          Cómo acceder a <b className="font-semibold text-[#dcd8cf]" data-id="element-72" data-mp="x3h1dycd8afq">Péptidos de Grado Médico Real</b>{' '}
          por una fracción de lo que pagan los demás, usando el Glitch de las Farmacias de Élite que
          las clínicas de $5,000 USD ruegan que nunca descubras.
        </p>

        {/* ── El vault: producto flotando sobre el pedestal de mármol ── */}
        <div className="perspective-stage relative flex min-h-[262px] w-full flex-1 items-end justify-center py-5 sm:min-h-[380px] sm:py-8" data-id="element-73" data-mp="21bxyn68yqubv">
          <div className="absolute bottom-8 h-[320px] w-[320px] rounded-full bg-[radial-gradient(circle,rgba(233,205,143,0.32),rgba(201,162,74,0.08)_45%,transparent_72%)] sm:h-[420px] sm:w-[420px] sm:animate-orb-pulse sm:blur-[4px]" aria-hidden="true" data-id="element-74" data-mp="267wjijv31u7j" />
          <span className="absolute left-4 top-0 h-8 w-8 border-l-[1.5px] border-t-[1.5px] border-gold-400/40 sm:left-16" aria-hidden="true" data-id="element-75" data-mp="2kx2hk4i6pedu" />
          <span className="absolute right-4 top-0 h-8 w-8 border-r-[1.5px] border-t-[1.5px] border-gold-400/40 sm:right-16" aria-hidden="true" data-id="element-76" data-mp="2tyaeoj8ys96c" />

          {motes.map(mote => <span key={`${mote.left}-${mote.delay}`} aria-hidden="true" className="absolute hidden h-[3px] w-[3px] rounded-full bg-gold-200/75 shadow-[0_0_6px_1px_rgba(233,205,143,0.5)] animate-rise sm:block" style={{
          left: mote.left,
          bottom: mote.bottom,
          animationDelay: mote.delay
        }} data-id="element-77" data-mp="zlswhq2zfz8k" />)}

          <div className="marble-plinth absolute bottom-0 h-6 w-[230px] rounded-[50%] border-t border-gold-400/50 shadow-[0_26px_46px_-8px_rgba(0,0,0,0.85)] sm:h-7 sm:w-[290px]" aria-hidden="true" data-id="element-78" data-mp="9bigfeqehkj2" />

          <div className="preserve-3d relative mb-6 h-[196px] w-[148px] animate-bob sm:mb-7 sm:h-[262px] sm:w-[196px]" data-id="element-79" data-mp="3ct0ljeesgdfs">
            <div className="glass-sheen relative h-full w-full overflow-hidden rounded-xl border border-gold-400/45 bg-gradient-to-br from-ink-700 to-[#070a0e] shadow-[0_30px_60px_-14px_rgba(0,0,0,0.8),0_40px_80px_-30px_rgba(201,162,74,0.35)]" data-id="element-80" data-mp="3rhwvjh0eo0j1">
              <img src={PRODUCT_IMAGE} alt="Protocolo Lujo de Farmacia: libro negro con letras doradas junto a un vial de farmacia sobre un mostrador de mármol" width={196} height={262} loading="eager" decoding="async" className="h-full w-full object-cover" data-id="element-81" data-mp="2tzn0q24shndw" />
            </div>

            <div className="reflection-mask absolute left-0 top-full hidden h-[70%] w-full overflow-hidden opacity-30 sm:block" aria-hidden="true" data-id="element-82" data-mp="14klyddc70lmk">
              <img src={PRODUCT_IMAGE} alt="" width={196} height={262} className="w-full -scale-y-100" data-id="element-83" data-mp="1x76sglk1zbtt" />
            </div>

            <div className="absolute -right-8 top-3 rounded-lg border border-gold-400/55 bg-ink-900/95 px-2.5 py-2 text-right font-mono shadow-[0_16px_34px_-10px_rgba(0,0,0,0.75)] sm:-right-12 sm:px-3" data-id="element-84" data-mp="1j7xaphg789nq">
              <div className="text-[8px] uppercase tracking-[0.09em] text-ash sm:text-[8.5px]" data-id="element-85" data-mp="7rqn7h992a97">
                Inversión hoy
              </div>
              <div className="text-base font-bold text-gold-300 sm:text-[17px]" data-id="element-86" data-mp="2ehaohk9pwc4u">
                ${todayPrice}
                <s className="ml-1.5 text-[10px] font-normal text-[#6f7684] sm:text-[11px]" data-id="element-87" data-mp="29hxumfkfi4sr">
                  ${listPrice}
                </s>
              </div>
            </div>

            <div className="absolute -left-10 bottom-12 flex items-center gap-1.5 rounded-lg border border-gold-400/55 bg-ink-900/95 px-2.5 py-1.5 font-mono shadow-[0_16px_34px_-10px_rgba(0,0,0,0.75)] sm:-left-14" data-id="element-88" data-mp="1zsxq6gn5qh76">
              <Check className="h-3.5 w-3.5 shrink-0 text-[#7fbf8f]" strokeWidth={2} aria-hidden="true" data-id="element-89" data-mp="1qrgagzdnwhj0" />
              <span className="whitespace-nowrap text-[8.5px] text-[#cfd4da] sm:text-[9.5px]" data-id="element-90" data-mp="1lupwqipbxy0r">
                Grado Médico Verificado
              </span>
            </div>
          </div>
        </div>

        {/* ── CTA ── */}
        <div className="flex w-full animate-fade-up flex-col items-center gap-2 sm:gap-2.5" style={{
        animationDelay: '240ms'
      }} data-id="element-91" data-mp="3b7bcvi66cqlm">
          <CtaButton label={`Sí, soy lo suficientemente inteligente — acceso inmediato por $${todayPrice}`} data-id="element-92" data-mp="3jmr22mam815q" />

          <div className="flex items-baseline gap-2.5 font-mono" data-id="element-93" data-mp="3sgnakyauxf2o">
            <span className="text-[11px] text-[#7c8494] line-through" data-id="element-94" data-mp="3sj8ctof2hx0y">
              ${totalValue.toLocaleString('en-US')} valor total
            </span>
            <span className="text-[11px] text-[#6f7684]" aria-hidden="true" data-id="element-95" data-mp="30r10h06lh6sd">
              →
            </span>
            <span className="text-base font-bold text-gold-300 sm:text-[17px]" data-id="element-96" data-mp="34scgqf3kwfnw">
              ${todayPrice}
              <span className="ml-1 text-[11px] font-normal text-ash" data-id="element-97" data-mp="39p2x73japd9u">hoy</span>
            </span>
          </div>

          <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 pt-1 sm:gap-x-5 sm:pt-2" data-id="element-98" data-mp="3ennvuyiwfow6">
            {trustItems.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5 font-mono text-[10px] text-[#9aa1ac] sm:text-[10.5px]" data-id="element-99" data-mp="ty88kdiw2iba">
                <Icon className="h-3 w-3 shrink-0 text-gold-400" strokeWidth={1.8} aria-hidden="true" data-id="element-100" data-mp="1b2id72f8anqg" />
                {label}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}